import { render, staticRenderFns } from "./lineasdeaccion.vue?vue&type=template&id=41fe5f06&"
import script from "./lineasdeaccion.vue?vue&type=script&lang=ts&"
export * from "./lineasdeaccion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports